import React from 'react'
import Moment from 'react-moment'
import 'moment/locale/es';
import getSymbolFromCurrency from "currency-symbol-map"
import { Tag, IconButton, Icon, Whisper, Tooltip } from 'rsuite';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { handleSimulate } from '../../hooks/transactionHook';

export const getColumns = (userSetting, reloadTable, t) => {

    return [
        {
            name: t('paid-leagues.columns.transaction'),
            selector: "idTransaction",
        },
        {
            name: t('paid-leagues.columns.reference'),
            selector: "referenceNumber",
            wrap: true,
            width: "210px",
        },
        {
            name: t('paid-leagues.columns.date'),
            selector: "date",
            format: (row) => (
                <Moment locale="es" format="DD/MM/YYYY hh:mm:ss A">
                    {row.date}
                </Moment>
            ),
            wrap: true,
            width: "115px",
        },
        {
            name: t('paid-leagues.columns.expirationDate'),
            selector: "expirationDate",
            format: (row) => (
                <Moment locale="es" format="DD/MM/YYYY hh:mm:ss A">
                    {row.expirationDate}
                </Moment>
            ),
            wrap: true,
            width: "115px",
        },
        {
            name: t('paid-leagues.columns.email'),
            selector: "email",
            wrap: true,
            width: "175px",
        },
        {
            name: t('paid-leagues.columns.amount'),
            selector: "amount",
            format: (row) =>
                getSymbolFromCurrency(row.currency) +
                row.amount.toLocaleString(userSetting.cultureCode, {
                    minimumFractionDigits: 2,
                }),
        },
        {
            name: t('paid-leagues.columns.status'),
            selector: "status",
            wrap: true,
            center: true,
            cell: (row) => (
                <span>
                    <span>
                        {{
                            "Accepted": <Tag color="green">{t('paid-leagues.columns.paid')}</Tag>,
                            "Transaction created": <Tag color="orange">{t('paid-leagues.columns.created')}</Tag>,
                            "Pending payment": <Tag color="orange">{t('paid-leagues.columns.pendingPayment')}</Tag>,
                            "Review": <Tag color="orange">{t('paid-leagues.columns.review')}</Tag>,
                            "Authorized": <Tag color="orange">{t('paid-leagues.columns.authorized')}</Tag>,
                            "Canceled by customer": <Tag color="red">{t('paid-leagues.columns.canceledByClient')}</Tag>,
                            "Expired": <Tag color="red">{t('paid-leagues.columns.expired')}</Tag>,
                            "Rejected": <Tag color="red">{t('paid-leagues.columns.rejected')}</Tag>,
                            "Reversed": <Tag color="red">{t('paid-leagues.columns.reversed')}</Tag>,
                            "Non-payment": <Tag color="red">{t('paid-leagues.columns.nonPayment')}</Tag>,
                            "Replaced": <Tag color="red">{t('paid-leagues.columns.replaced')}</Tag>,
                            "Authorization expired": <Tag color="red">{t('paid-leagues.columns.authorizationExpired')}</Tag>,
                            "Expired cash payment": <Tag color="red">{t('paid-leagues.columns.cashPaymentExpired')}</Tag>
                        }[row.status]}
                    </span >
                </span>
            ),
        },
        {
            name: t('paid-leagues.columns.actions'),
            selector: "url",
            center: true,
            cell: (row) => (
                <>
                    <span className="box_ico_table">
                        <CopyToClipboard text={row.url}>
                            <Whisper
                                placement="bottom"
                                trigger="hover"
                                speaker={<Tooltip>{t('paid-leagues.columns.copyToClipboard')}</Tooltip>}
                            >
                                <IconButton
                                    className="mr-2"
                                    icon={<Icon icon="copy" />}
                                    circle
                                    size="md"
                                />
                            </Whisper>
                        </CopyToClipboard>
                        {/*<Whisper
            placement="bottom"
            trigger="hover"
            speaker={<Tooltip>Cancelar liga</Tooltip>}
          >
            <IconButton
              className="mr-2"
              icon={<Icon icon="ban" />}
              circle
              size="md"
              // onClick={() => handleAction(2, row.idTransaction)}
            />
          </Whisper>*/}
                    </span>
                    {(row.status === "Pending payment" && userSetting.environment === "MODO PRUEBAS") &&
                        <span className="box_ico_table" onClick={() => handleSimulate(row.idTransaction, reloadTable)} >
                            <Whisper
                                placement="bottom"
                                trigger="hover"
                                speaker={<Tooltip>Simular Pago</Tooltip>}
                            >
                                <IconButton
                                    className="mr-2"
                                    icon={<Icon icon="shopping-cart" />}
                                    circle
                                    size="md"
                                />
                            </Whisper>
                        </span>
                    }
                </>
            ),
        },
    ];
}